import { JIRA_LABELS } from 'src/common/consts/jira-labels';
import { ProductType } from 'src/common/interfaces/Tenant';
import { PlatformIssueDetails } from 'src/common/types/IssueDetailsType';
import { Report } from 'src/common/types/ReportModel';

export const getJiraLabelBySource = (source: ProductType): string => {
	switch (source) {
		case ProductType.WEB_FLOW_ANALYZER:
			return JIRA_LABELS.evincedWfaIssue;
		case ProductType.WEB_SDK:
			return JIRA_LABELS.evinceWebSDKIssue;
		case ProductType.MOBILE_FLOW_ANALYZER:
			return JIRA_LABELS.evincedMFAIssue;
		case ProductType.MOBILE_SDK:
			return JIRA_LABELS.evincedmobileSDKIssue;
		default:
			return JIRA_LABELS.evincedWfaIssue;
	}
};

export const mapPlatformIssueDetailsToReport = (
	issue: PlatformIssueDetails | undefined,
	isDefaultLabelsEnabled: boolean,
	source: ProductType
): Report => {
	const { url, severity, type, screenshotUrl } = issue || {};

	return {
		...issue,
		pageUrl: url,
		signature: '',
		severity: { id: severity, name: severity, newId: severity },
		type: { id: type, name: type, newId: type },
		pageScreenshot: screenshotUrl,
		labels: isDefaultLabelsEnabled ? [getJiraLabelBySource(source)] : []
	};
};
